import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-100 mx-auto d-flex justify-content-center" }
const _hoisted_2 = { class: "w-100 mx-auto d-flex justify-content-center" }
const _hoisted_3 = { class: "w-100 mx-auto d-flex justify-content-center" }
const _hoisted_4 = { class: "w-100 mx-auto d-flex justify-content-center" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex justify-content-center text-green"
}

import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import { formatDateTime } from '@/services/functions';
import DeliveryPlan from "@/types/DeliveryPlan";
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const MAX_SELECTABLE_LENGTH = 5;


export default /*@__PURE__*/_defineComponent({
  __name: 'TableContent',
  props: {
    modelValue: {},
    deliveryPlans: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

function addDeliveryPlan(deliveryPlan: DeliveryPlan) {
  if (isMaxSelected.value) {
    return;
  }
  modelValue.value.push(deliveryPlan);
  modelValue.value = [...modelValue.value].sort((a, b) => {
    const dateA = new Date(a.leaving_warehouse_date_time);
    const dateB = new Date(b.leaving_warehouse_date_time);
    return dateA.getTime() - dateB.getTime();
  });
}

const isSelected = computed(() => (deliveryPlan: DeliveryPlan) => {
  return props.modelValue.some((plan) => plan.delivery_plan_id === deliveryPlan.delivery_plan_id);
})

const isMaxSelected = computed(() => {
  return props.modelValue.length >= MAX_SELECTABLE_LENGTH;
})

function changeFormat(dateTime: Date | string) {
  return typeof dateTime === 'string' ? formatDateTime(new Date(dateTime)) : formatDateTime(dateTime);
}

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("tbody", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.deliveryPlans, (deliveryPlan) => {
      return (_openBlock(), _createElementBlock("tr", {
        key: deliveryPlan.delivery_plan_id
      }, [
        _createElementVNode("td", null, [
          _createElementVNode("span", _hoisted_1, _toDisplayString(deliveryPlan.delivery_plan_id), 1)
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(deliveryPlan.car_number), 1)
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(changeFormat(deliveryPlan.leaving_warehouse_date_time)), 1)
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(changeFormat(deliveryPlan.returning_warehouse_date_time)), 1)
        ]),
        _createElementVNode("td", null, [
          (isSelected.value(deliveryPlan))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "material-symbols-outlined" }, " check ", -1)
              ]))]))
            : (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                variant: "text",
                class: _normalizeClass(["d-flex justify-content-center ml-2", isMaxSelected.value ? 'text-grey-lighten-1' : 'text-blue']),
                onClick: ($event: any) => (addDeliveryPlan(deliveryPlan))
              }, {
                default: _withCtx(() => [
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "material-symbols-outlined" }, " add_circle ", -1)),
                  (isMaxSelected.value)
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 0,
                        activator: "parent"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(i18n).global.t(`pages.dailyReports.combineForm.maxSelectedMessage`)), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class", "onClick"]))
        ])
      ]))
    }), 128))
  ]))
}
}

})